import { render, staticRenderFns } from "./SearchOverlay.vue?vue&type=template&id=465c8da0"
import script from "./SearchOverlay.vue?vue&type=script&lang=ts"
export * from "./SearchOverlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports